import { useCallback, useState } from "react";

import type { FormSubmitAction } from "../types/FormProps";

/**
 * Drives the Submit/Ok buttons on a form page. Both buttons trigger the same validation
 * pass on the form (a single incrementing counter), but `formAction` records which one was
 * clicked so the form component knows whether to redirect (ok) or stay on the page (submit / save).
 */
export const useFormSubmitTrigger = () => {
    const [runSubmit, setRunSubmit] = useState(0);
    const [formAction, setFormAction] = useState<FormSubmitAction>("save");

    const trigger = useCallback((action: FormSubmitAction) => {
        setFormAction(action);
        setRunSubmit((prev) => prev + 1);
    }, []);

    const triggerSubmit = useCallback(() => trigger("save"), [trigger]);
    const triggerOk = useCallback(() => trigger("ok"), [trigger]);
    const triggerGenerate = useCallback(() => trigger("generate"), [trigger]);

    return { runSubmit, formAction, triggerSubmit, triggerOk, triggerGenerate };
};
